/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 1 = Labor

2 = Material

3 = Equipment

4 = Subcontractor

5 = Bid

6 = Allowance

7 = Other

-1 = None


 */
export type CostTypes = (typeof CostTypes)[keyof typeof CostTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostTypes = {
  Labor: 1,
  Material: 2,
  Equipment: 3,
  Subcontractor: 4,
  Bid: 5,
  Allowance: 6,
  Other: 7,
  None: -1,
} as const;
